import type { FormInstance } from '@arco-design/web-react';
import get from 'lodash/get';

import { mergeHealthCheckIntoContainerDeployConfig } from '@/delivery-type-plugin/capabilities/health-check';

/** 镜像 containerDeployConfig 持久化字段（提交 / 回填 / 预置约束真源） */
export const SYSTEM_OPTIONS_CONTAINER_DEPLOY_CONFIG_FIELD = 'system.options.containerDeployConfig';

/** 将镜像 containerDeployConfig 规范为表单存储用的 JSON 字符串 */
export function normalizeContainerDeployConfigStorage(raw: unknown): string | undefined {
  if (raw == null || raw === '') return undefined;
  if (typeof raw === 'string') {
    const text = raw.trim();
    return text || undefined;
  }
  try {
    return JSON.stringify(raw);
  } catch {
    return undefined;
  }
}

/** 从表单读取已存储的 containerDeployConfig（优先 system.options，兼容 legacy basic.image） */
export function readStoredContainerDeployConfig(values: Record<string, unknown>): string | undefined {
  const fromOptions = normalizeContainerDeployConfigStorage(get(values, SYSTEM_OPTIONS_CONTAINER_DEPLOY_CONFIG_FIELD));
  if (fromOptions) return fromOptions;
  return normalizeContainerDeployConfigStorage(get(values, 'basic.image.containerDeployConfig'));
}

export function writeStoredContainerDeployConfig(form: FormInstance, raw: unknown): void {
  const normalized = normalizeContainerDeployConfigStorage(raw);
  form.setFieldValue(SYSTEM_OPTIONS_CONTAINER_DEPLOY_CONFIG_FIELD, normalized);
}

export function clearStoredContainerDeployConfig(form: FormInstance): void {
  form.setFieldValue(SYSTEM_OPTIONS_CONTAINER_DEPLOY_CONFIG_FIELD, undefined);
}

/** 构建 system.options 提交片段（含用户编辑的探活配置） */
export function buildSystemOptionsFromForm(values: Record<string, unknown>): { containerDeployConfig?: string } | undefined {
  const containerDeployConfig = readStoredContainerDeployConfig(values);
  if (!containerDeployConfig) return undefined;
  try {
    const parsed = JSON.parse(containerDeployConfig) as Record<string, unknown>;
    const merged = mergeHealthCheckIntoContainerDeployConfig(parsed, values);
    if (!merged) return undefined;
    return { containerDeployConfig: JSON.stringify(merged) };
  } catch {
    return { containerDeployConfig };
  }
}
